var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"teal--text text--darken-4"},[_vm._v("Albums photos")]),_c('br'),_vm._v(" En construction ")])}]

export { render, staticRenderFns }